import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import Car from './pages/Car';
import OuterContainer from './include/OuterContainer';
import Chatbot from './pages/Chatbot';
import Finished from './pages/Finished';
import { useRecoilState } from 'recoil';
import { carInfoState } from './recoil/atom';

const App = () => {
  const [carInfo, setCarInfo] = useRecoilState(carInfoState);
  console.log("🚀 ~ App ~ carInfo:", carInfo)

  return (
    <OuterContainer>
      <Router>
        <Routes>
          <Route path="/" element={<Car />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/finished" element={<Finished />} />
        </Routes>
      </Router>
    </OuterContainer>
  );
};

export default App;
